import mediaQueryListFactory from '../common/media-query-list';

const OPEN_DELAY = 180;
const CLOSE_DELAY = 220;
const ANIMATION_DURATION = 180;
const DEFAULT_PANEL_HEIGHT = 450;

export default function () {
    const mediumMediaQueryList = mediaQueryListFactory('medium');
    const $menu = $('.header--bottom .navPages-list').first();
    const $items = $menu.children('.navPages-item');
    const $overlay = $('.body .nav-overlay');
    let isDesktop = mediumMediaQueryList.matches;
    let openTimer = null;
    let closeTimer = null;
    let $openItem = null;
    let isRestoringTriggerFocus = false;

    function clearOpenTimer() {
        window.clearTimeout(openTimer);
        openTimer = null;
    }

    function clearCloseTimer() {
        window.clearTimeout(closeTimer);
        closeTimer = null;
    }

    function panelFor($item) {
        return $item.children('.navPage-subMenu').first();
    }

    function linkFor($item) {
        return $item.children('.navPages-action.has-subMenu').first();
    }

    function restoreTriggerFocus(link) {
        if (!link) {
            return;
        }

        isRestoringTriggerFocus = true;
        link.focus({ preventScroll: true });
        isRestoringTriggerFocus = false;
    }

    function closeItem($item, animate = true) {
        if (!$item || !$item.length) {
            return;
        }

        const $panel = panelFor($item);
        const $link = linkFor($item);

        $link.removeClass('is-mega-open').attr('aria-expanded', 'false');
        $panel
            .stop(true, true)
            .attr('aria-hidden', 'true');

        if (animate) {
            $panel.animate({ opacity: 0, height: 0 }, ANIMATION_DURATION, () => {
                $panel.removeClass('is-open').removeAttr('style');
            });
        } else {
            $panel.removeClass('is-open').removeAttr('style');
        }
    }

    function closeMenu(animate = true) {
        clearOpenTimer();
        clearCloseTimer();
        closeItem($openItem, animate);
        $openItem = null;

        $overlay.stop(true, true);
        if (animate) {
            $overlay.animate({ opacity: 0 }, ANIMATION_DURATION, () => {
                $overlay.css({ display: 'none' });
            });
        } else {
            $overlay.css({ display: 'none', opacity: 0 });
        }
    }

    function openMenu($item) {
        if (!isDesktop || !$item || !$item.length) {
            return;
        }

        const $panel = panelFor($item);
        const $link = linkFor($item);

        if (!$panel.length || !$link.length) {
            closeMenu();
            return;
        }

        clearOpenTimer();
        clearCloseTimer();

        // Focusing a link inside an already-open panel must not restart the
        // height animation. Doing so on mousedown collapses the link before
        // mouseup, so the shopper's click never reaches its destination.
        if ($openItem && $openItem.is($item) && $panel.hasClass('is-open')) {
            $link.addClass('is-mega-open').attr('aria-expanded', 'true');
            $panel.attr('aria-hidden', 'false');
            return;
        }

        if ($openItem && !$openItem.is($item)) {
            closeItem($openItem, false);
        }

        $openItem = $item;
        // Keep the desktop mega-menu state separate from Stencil's collapsible
        // `is-open` class. The core class changes trigger backgrounds and icon
        // layout, which makes the navigation jump as the pointer crosses it.
        $link.addClass('is-mega-open').attr('aria-expanded', 'true');
        $panel
            .stop(true, true)
            .addClass('is-open')
            .attr('aria-hidden', 'false')
            .css({ display: 'block', opacity: 0, height: 0 })
            .animate({ opacity: 1, height: DEFAULT_PANEL_HEIGHT }, ANIMATION_DURATION);

        $overlay
            .stop(true, true)
            .css({ display: 'flex' })
            .animate({ opacity: 1 }, ANIMATION_DURATION);
    }

    function scheduleOpen($item) {
        clearOpenTimer();
        clearCloseTimer();

        if ($openItem && $openItem.is($item)) {
            return;
        }

        openTimer = window.setTimeout(() => openMenu($item), OPEN_DELAY);
    }

    function scheduleClose() {
        clearOpenTimer();
        clearCloseTimer();
        closeTimer = window.setTimeout(() => closeMenu(), CLOSE_DELAY);
    }

    $items
        .off('.obMegaMenu')
        .on('mouseenter.obMegaMenu', function () {
            const $item = $(this);

            if (linkFor($item).length) {
                scheduleOpen($item);
            } else {
                scheduleClose();
            }
        })
        .on('focusin.obMegaMenu', function () {
            if (isRestoringTriggerFocus) {
                return;
            }

            const $item = $(this);

            if (linkFor($item).length) {
                openMenu($item);
            }
        })
        .on('focusout.obMegaMenu', function (event) {
            if (!this.contains(event.relatedTarget)) {
                scheduleClose();
            }
        })
        .on('keydown.obMegaMenu', function (event) {
            if (event.key !== 'Escape' || !$openItem || !$openItem.is(this)) {
                return;
            }

            const link = linkFor($openItem).get(0);

            event.preventDefault();
            event.stopPropagation();
            closeMenu(false);

            restoreTriggerFocus(link);
        });

    $items.find('.navPage-subMenu')
        .off('.obMegaMenu')
        .on('mouseenter.obMegaMenu focusin.obMegaMenu', () => {
            // A diagonal pointer path can briefly cross another top-level item
            // before it reaches the full-width panel. Once the pointer lands in
            // the active panel, cancel both the close and stray open timers.
            clearOpenTimer();
            clearCloseTimer();
        });

    $items.find('.navPages-action.has-subMenu')
        .attr('aria-expanded', 'false')
        .off('click.obMegaMenu keydown.obMegaMenu')
        .on('click.obMegaMenu', function (event) {
            if (!isDesktop) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            const $item = $(this).parent('.navPages-item');

            if ($openItem && $openItem.is($item)) {
                clearCloseTimer();
                return;
            }

            openMenu($item);
        })
        .on('keydown.obMegaMenu', function (event) {
            const $item = $(this).parent('.navPages-item');

            if (event.key === 'ArrowDown') {
                event.preventDefault();
                openMenu($item);
                // The panel starts its height animation at zero, so jQuery's
                // `:visible` filter can reject valid links at this exact moment.
                const firstPanelLink = panelFor($item)
                    .find('a[href]:not([tabindex="-1"])')
                    .first()
                    .get(0);

                if (firstPanelLink) {
                    firstPanelLink.focus({ preventScroll: true });
                }
            } else if (event.key === ' ' || event.key === 'Spacebar') {
                event.preventDefault();
                openMenu($item);
            } else if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                closeMenu(false);
                restoreTriggerFocus(this);
            }
        });

    $menu
        .off('mouseleave.obMegaMenu')
        .on('mouseleave.obMegaMenu', scheduleClose);

    $(document)
        .off('click.obMegaMenu keydown.obMegaMenu')
        .on('click.obMegaMenu', (event) => {
            if (isDesktop && $openItem && !$(event.target).closest('.header--bottom .navPages-list').length) {
                closeMenu(false);
            }
        })
        .on('keydown.obMegaMenu', (event) => {
            if (event.key === 'Escape' && $openItem) {
                const link = linkFor($openItem).get(0);

                event.preventDefault();
                closeMenu(false);

                restoreTriggerFocus(link);
            }
        });

    if (mediumMediaQueryList && mediumMediaQueryList.addEventListener) {
        mediumMediaQueryList.addEventListener('change', (event) => {
            isDesktop = event.matches;

            if (!isDesktop) {
                closeMenu(false);
            }
        });
    }
}
